import { mb, flex, PanelLayout } from '@openeducation/oe-rn-components';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { PortalLayout } from '../../templates/portal-layout/portal-layout';

export type PCCommonFeedbackProps = {
  children: JSX.Element;
  rightSideBar?: JSX.Element;
  panelStyle?: StyleProp<ViewStyle>;
};
export const PCCommonFeedback = ({
  children,
  rightSideBar,
  panelStyle,
}: PCCommonFeedbackProps) => {
  return (
    <PortalLayout>
      <View style={flex('flex-row', 'justify-content-between')}>
        <PanelLayout style={[panelStyle, mb(40)]}>{children}</PanelLayout>
        {rightSideBar}
      </View>
    </PortalLayout>
  );
};
